<h2 mat-dialog-title style="text-align: center;">Biztosan törölni szeretnéd?</h2>

<mat-divider style="margin-bottom: 1rem;"></mat-divider>
<mat-dialog-actions align="center">
  <button mat-raised-button [mat-dialog-close]="true">Mégse</button>
  <button mat-raised-button color="primary" cdkFocusInitial (click)="onDelete()">Törlés</button>
</mat-dialog-actions>
